<template>
    <a-row wrap
           justify="space-between"
           align="middle">

        <a-col :xs="24"
               :lg="12">
            <a-row align="middle"
                   :gutter="5">
                <a-col flex="0 0"><i class="n-icon n-icon-project n-c-base"></i></a-col>
                <a-col flex="1 1">
                    <a-select v-model:value="projectValue"
                              size="middle"
                              class="n-col-1"
                              placeholder="请选择项目"
                              :options="projectOptions"
                              @change="projectChange"></a-select>
                </a-col>
            </a-row>
        </a-col>

        <a-col :xs="24"
               :lg="12"
               class="ctrl-row">
            <a-row justify="end"
                   :gutter="10">
                <a-col>
                    <a-button type="primary"
                              :disabled="!projectValue"
                              @click="exportTask">导出清单</a-button>
                </a-col>

                <a-col>
                    <a-button type="primary"
                              :disabled="!projectValue"
                              @click="createTask">新建任务</a-button>
                </a-col>
                <a-col v-if="type == 'panel'">
                    <a-button type="primary"
                              :disabled="!projectValue"
                              @click="addGroup">新建分组</a-button>
                </a-col>
                <a-col v-if="type == 'list'">
                    <a-popconfirm title="确认删除选中任务？"
                                  ok-text="删除"
                                  placement="leftTop"
                                  cancel-text="取消"
                                  :disabled="task.selectedRowKeys.length <= 0"
                                  @confirm="deleteTask">
                        <a-button type="primary"
                                  danger
                                  :disabled="task.selectedRowKeys.length <= 0">删除</a-button>
                    </a-popconfirm>
                </a-col>
            </a-row>
        </a-col>
    </a-row>

    <a-row class="n-mt-3"
           align="middle"
           :gutter="5"
           :wrap="false">
        <a-col class="n-flex-s">
            <label class="n-mtb-1">搜索条件：</label>
        </a-col>
        <a-col>
            <a-tag v-for="(item, index) in parseFilterTags(filter, type)"
                   closable
                   class="n-mtb-1"
                   @close="deleteFilter(item)"
                   :key="index">{{item.title}}</a-tag>
        </a-col>
        <a-col class="n-flex-s">
            <span class="n-c-base n-pointer n-mtb-1"
                  @click="showFilter = true">编辑条件</span>
        </a-col>
    </a-row>

    <div class="c-tab-container">
        <a-tabs v-model:activeKey="type"
                type="card"
                destroyInactiveTabPane
                class="n-mt-3"
                @change="tabChange">
            <template #rightExtra>
                <a-dropdown placement="bottomRight"
                            v-model:visible="showSetting">
                    <template #overlay>
                        <a-menu @click="() => {}">
                            <a-menu-item v-for="(item, index) in task.ctrlColumns.filter(item => !item.fixedShow)"
                                         :key="index">
                                <a-row :gutter="5">
                                    <a-col flex="1">
                                        {{item.title}}
                                    </a-col>
                                    <a-col>
                                        <a-switch v-model:checked="item.show"
                                                  @change="setTable" />
                                    </a-col>
                                </a-row>
                            </a-menu-item>
                        </a-menu>
                    </template>
                    <a-button type="warn"
                              @click="showSetting = true"
                              v-if="type == 'list'">
                        显示设置
                        <i class="n-icon n-icon-arrow-down n-inline-block n-icon-size-15 n-ml-1"></i>
                    </a-button>
                </a-dropdown>
            </template>
            <a-tab-pane key="list"
                        tab="列表"
                        class="n-bg-1 n-p-2 c-tab">
                <a-table :dataSource="task.datas"
                         :columns="task.columns"
                         :pagination="task.pageInfo"
                         :loading="task.loading"
                         :row-selection="{ fixed:true, selectedRowKeys: task.selectedRowKeys, onChange: onSelectChange, getCheckboxProps: (record) => {return {disabled: !!record.children}} }"
                         v-model:expandedRowKeys="task.expandedRowKeys"
                         :bordered="true"
                         :scroll="{ x: 1000 }"
                         tableLayout="fixed"
                         size="small"
                         @change="tableChange"
                         @expand="tableExpand">

                    <template #bodyCell="{ column, record }">

                        <template v-if="column.key == 'title'">
                            <a-row>
                                <a-col class="n-pointer n-e-1">{{record.title}}</a-col>
                            </a-row>
                        </template>

                        <template v-if="column.key == 'level'">
                            <a-row align="middle"
                                   :gutter="[5]">
                                <a-col>
                                    <i class="c-priority-bg c-priority-bg-circle"
                                       :class="'c-priority-bg-' + record.level||'low'"></i>
                                </a-col>
                                <a-col>{{ getLevel(record.level).title }}</a-col>
                            </a-row>
                        </template>

                        <template v-if="column.key == 'status'">
                            <a-select v-model:value="record.status"
                                      size="small"
                                      class="c-status"
                                      :class="'c-status-' + record.status"
                                      :loading="record.statusLoading"
                                      :options="status.map(item => {item.disabled = item.value == 0; return item})"
                                      @change="(res) => {updateTaskStatus(res, record)}"
                                      @click.stop>
                            </a-select>
                        </template>

                        <template v-if="column.dataIndex === 'ctrl'">
                            <a-button size="small"
                                      class="n-mr-2"
                                      type="primary"
                                      @click.stop="createTask(record)">子任务</a-button>

                            <a-button size="small"
                                      type="primary"
                                      @click.stop="editTask(record)">编辑</a-button>
                        </template>
                    </template>
                </a-table>
            </a-tab-pane>
            <a-tab-pane key="panel"
                        tab="看板"
                        class="n-bg-1 c-tab n-p-2">
                <div class="c-max-width"
                     v-if="group.length > 0">
                    <div class="n-col-1 n-flex n-scroll-h"
                         ref="panelScroll">
                        <div class="c-task-panel-item n-flex-s n-mr-2"
                             v-for="item in group"
                             :key="item.id">

                            <a-card class="n-bg-2 n-col-1 n-h-1">

                                <template #title>
                                    <a-input :defaultValue="item.name"
                                             :ref="'groupName' + item.id"
                                             :maxlength="255"
                                             placeholder="请输入分组名"
                                             v-if="item.edit"
                                             show-count />
                                    <span v-else>{{item.name}}</span>
                                </template>

                                <template #extra>
                                    <a-button size="small"
                                              type="primary"
                                              shape="circle"
                                              class="n-ml-2"
                                              @click="saveGroup(item)"
                                              v-if="item.edit"><i class="n-icon n-icon-right n-icon-size-15"></i></a-button>

                                    <a-dropdown placement="bottomRight"
                                                :trigger="['click']"
                                                v-else>
                                        <template #overlay>
                                            <a-menu>
                                                <a-menu-item @click="edit(item)">重命名</a-menu-item>
                                                <a-menu-item @click="deleteGroup(item)">删除</a-menu-item>
                                                <a-menu-item>
                                                    <div class="n-flex n-flex-a-c"
                                                         @click.stop="() => {}">
                                                        <span class="n-inline-block n-mr-1">子任务</span>
                                                        <a-switch checked-children="显"
                                                                  un-checked-children="隐"
                                                                  v-model:checked="item.showChildren"
                                                                  @change="setBoardFilterCache(item)" />
                                                    </div>
                                                </a-menu-item>
                                                <a-menu-item>
                                                    <div class="n-flex n-flex-a-c"
                                                         @click.stop="() => {}">
                                                        <span class="n-inline-block n-mr-1">已完成</span>
                                                        <a-switch checked-children="显"
                                                                  un-checked-children="隐"
                                                                  v-model:checked="item.showComplete"
                                                                  @change="setBoardFilterCache(item)" />
                                                    </div>
                                                </a-menu-item>
                                                <a-menu-item>
                                                    <div class="n-flex n-flex-a-c"
                                                         @click.stop="() => {}">
                                                        <span class="n-inline-block n-mr-1">进行中</span>
                                                        <a-switch checked-children="显"
                                                                  un-checked-children="隐"
                                                                  v-model:checked="item.showProgress"
                                                                  @change="setBoardFilterCache(item)" />
                                                    </div>
                                                </a-menu-item>
                                                <a-menu-item>
                                                    <div class="n-flex n-flex-a-c"
                                                         @click.stop="() => {}">
                                                        <span class="n-inline-block n-mr-1">暂停中</span>
                                                        <a-switch checked-children="显"
                                                                  un-checked-children="隐"
                                                                  v-model:checked="item.showSuspend"
                                                                  @change="setBoardFilterCache(item)" />
                                                    </div>
                                                </a-menu-item>
                                                <a-menu-item>
                                                    <div class="n-flex n-flex-a-c"
                                                         @click.stop="() => {}">
                                                        <span class="n-inline-block n-mr-1">未开始</span>
                                                        <a-switch checked-children="显"
                                                                  un-checked-children="隐"
                                                                  v-model:checked="item.showPending"
                                                                  @change="setBoardFilterCache(item)" />
                                                    </div>
                                                </a-menu-item>
                                                <a-menu-item>
                                                    <div class="n-flex n-flex-a-c"
                                                         @click.stop="() => {}">
                                                        <span class="n-inline-block n-mr-1">已逾期</span>
                                                        <a-switch checked-children="显"
                                                                  un-checked-children="隐"
                                                                  v-model:checked="item.showOutdate"
                                                                  @change="setBoardFilterCache(item)" />
                                                    </div>
                                                </a-menu-item>
                                            </a-menu>
                                        </template>

                                        <i class="n-icon n-icon-setting n-inline-block n-icon-size-20 n-c-2 n-ml-2 n-pointer"></i>
                                    </a-dropdown>
                                </template>

                                <a-spin :spinning="item.loading">
                                    <div class="c-task-list n-scroll-v"
                                         style="min-height: 260px;">
                                        <ul class="n-ul n-m-0 n-p-0"
                                            :group="item.id">

                                            <template v-for="(sItem) in item.taskList"
                                                      :key="sItem.taskId">
                                                <li class="c-task-tag n-bg-1 n-plr-2 n-pt-2 n-pb-1 n-radius-3 n-pointer c-task-list-item n-mb-3"
                                                    ref="dragItem"
                                                    :id="sItem.taskId"
                                                    v-tap="{tap: viewTask, param: sItem}"
                                                    v-if="checkShow(item, sItem)">
                                                    <a-row align="middle"
                                                           :wrap="false"
                                                           justify="space-between">
                                                        <a-col flex="1">
                                                            <a-row align="middle"
                                                                   :wrap="false"
                                                                   :gutter="5">
                                                                <a-col><i class="c-priority-bg c-priority-bg-circle"
                                                                       :class="'c-priority-bg-' + sItem.priority||'low'"></i></a-col>
                                                                <a-col class="n-e-1">{{sItem.taskName}}</a-col>
                                                            </a-row>
                                                        </a-col>
                                                        <a-col flex="0 0 60px"
                                                               class="n-text-right">
                                                            <span class="c-status-bg n-c-1 n-radius-3 n-plr-1"
                                                                  :class="'c-status-bg-' + sItem.status">{{getStatus(sItem.status).title}}</span>
                                                        </a-col>
                                                    </a-row>
                                                    <a-row align="middle"
                                                           class="n-mt-3"
                                                           :wrap="false"
                                                           :gutter="5">
                                                        <a-col><i class="n-icon n-icon-project c-status c-status-pending n-icon-size-20"></i></a-col>
                                                        <a-col class="n-c-2">{{sItem.principalList.join('，')}}</a-col>
                                                    </a-row>
                                                </li>
                                            </template>
                                            <li class="c-task-list-empty"
                                                v-if="item.taskList.length <= 0">
                                                <a-empty description="该分组下还没有任何任务" />
                                            </li>
                                        </ul>

                                    </div>
                                </a-spin>
                            </a-card>
                        </div>
                    </div>
                </div>

                <div class="n-mt-6"
                     v-else>
                    <a-empty :description="projectValue ? '暂无分组，请点击右上角添加' : '暂无分组，请先选择项目'" />
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>

    <AddTaskBox :visible="showAddTask"
                :projectValue="projectValue"
                :projectOptions="projectOptions"
                :parentTaskCache="parentTaskCache"
                :zIndex="10"
                ref="addTaskBox"
                title="新建任务"
                from="projectTask"
                @viewOtherTask="viewOtherTask"
                @close="showAddTask = false"
                @success="projectChange"
                @delete="projectChange"></AddTaskBox>

    <AddTaskBox :visible="showEditTask"
                :projectValue="projectValue"
                :projectOptions="projectOptions"
                :parentTaskCache="parentTaskCache"
                :zIndex="5"
                ref="editTaskBox"
                title="编辑任务"
                @viewOtherTask="viewOtherTask"
                @close="showEditTask = false"
                @success="projectChange"
                @delete="projectChange"
                @addSubTask="createTask"></AddTaskBox>

    <FilterTask :visible="showFilter"
                :zIndex="5"
                :projectValue="projectValue"
                :filterType="type"
                :defaultFilter="filter"
                ref="filterTask"
                @close="showFilter = false"
                @change="updateFilter"></FilterTask>
</template>
<script >
    import { createVNode } from 'vue';
    import Sortable from 'sortablejs';
    // import { Draggable } from '@shopify/draggable';
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    import AddTaskBox from '@/components/AddTaskBox'
    import FilterTask from '@/components/FilterTask'

    export default {
        name: 'ProjectTask',
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['status', 'level'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                type: 'list',
                projectValue: null,
                projectOptions: [],
                parentTaskCache: undefined,

                task: {
                    loading: false,
                    datas: [],
                    columns: [],
                    pageInfo: {
                        total: 0,
                        current: 1,
                        pageSize: 10,
                        showSizeChanger: true,
                        size: 'middle'
                    },
                    selectedRowKeys: [],
                    selectedRows: [],
                    expandedRowKeys: [],
                    expandedRowKeysPending: [],
                    ctrlColumns: [
                        {
                            title: '项目标题',
                            dataIndex: 'title',
                            key: 'title',
                            width: 250,
                            fixedShow: true,
                            ellipsis: true,
                            customCell: (record) => {
                                return {
                                    onClick: () => {
                                        this.viewTask(record)
                                    }
                                }
                            }
                        },
                        { title: '优先级', dataIndex: 'level', key: 'level', width: 90, fixedShow: true, ellipsis: true },
                        { title: '状态', dataIndex: 'status', key: 'status', width: 96, fixedShow: true, ellipsis: true },
                        { title: '创建人', dataIndex: 'creator', key: 'creator', width: 90, show: true, ellipsis: true },
                        { title: '负责人', dataIndex: 'charge', key: 'charge', width: 120, show: true, ellipsis: true },
                        { title: '执行人', dataIndex: 'executor', key: 'executor', width: 120, show: true, ellipsis: true },
                        { title: '开始日期', dataIndex: 'start', key: 'start', width: 90, show: true, ellipsis: true },
                        { title: '截止日期', dataIndex: 'end', key: 'end', width: 90, show: true, ellipsis: true }
                    ]
                },

                showSetting: false,

                showAddTask: false,
                showEditTask: false,

                group: [],


                dragObj: [],

                filter: {
                    title: '',
                    start: null,
                    end: null,
                    charge: [],
                    charges: [],
                    executor: [],
                    executors: [],
                    tag: [],
                    tags: [],
                    onlyLeader: [],
                    onlyLeaders: []
                },
                showFilter: false
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat([])),

            NMounted () {

                this.filter.onlyLeaders = this.getOnlyLeaderCache()
                this.filter.onlyLeader = this.filter.onlyLeaders.map(item => item.adName)

                this.getCustom(() => {
                    var tableShowCache = JSON.parse(localStorage.getItem('PCS') || '{"creator":true,"charge":true,"executor":true,"start":true,"end":true}');

                    this.task.ctrlColumns = this.task.ctrlColumns.map(item => {
                        if (!item.fixedShow) {
                            item.show = tableShowCache[item.key]
                        } else {
                            item.show = true
                        }

                        return item
                    })

                    this.setTable()
                    this.getProject();
                })

                var cacheTab = this.getProjectTaskTabCache();

                if (cacheTab) {
                    this.type = cacheTab;
                }

                this.setProjectTaskTabCache()
            },
            updateFilter (data) {
                this.filter = data;
                this.getTask();
                this.getGroup()
                this.setOnlyLeaderCache()
            },
            setOnlyLeaderCache () {
                localStorage.setItem('BOLS', JSON.stringify(this.filter.onlyLeaders.filter(item => this.filter.onlyLeader.filter(fItem => fItem == item.adName).length > 0)))
            },
            getOnlyLeaderCache () {
                return JSON.parse(localStorage.getItem('BOLS') || '[]')
            },
            initDrag () {
                document.querySelectorAll('.c-task-list ul').forEach(item => {
                    this.dragObj.push(Sortable.create(item, {
                        group: 'task',
                        sort: false,
                        animation: 100,
                        touchStartThreshold: 10,
                        onEnd: (res) => {
                            var newGroup = res.to.getAttribute('group'),
                                oldGroup = res.from.getAttribute('group'),
                                id = res.item.getAttribute('id'),
                                cache = this.extend([], this.group), target

                            if (newGroup == oldGroup) {
                                return
                            }

                            this.request(this.API.updateTaskGroup, {
                                method: 'post',
                                data: { taskId: id, groupId: newGroup }
                            }).then(res => {
                                if (res.code != this.REQUEST_SUCCESS_CODE) {
                                    this.error(res.msg)
                                }
                            })
                        }
                    }));
                })
            },
            viewOtherTask (taskId) {
                this.showAddTask = false;
                this.showEditTask = false;
                this.parentTaskCache = {};
                setTimeout(() => {
                    this.showEditTask = true;
                    this.$nextTick(() => {
                        this.$refs.editTaskBox.getDetail(taskId, false)
                    })
                }, 50);
            },
            setTable () {
                this.task.columns = this.task.ctrlColumns.filter(item => item.fixedShow || item.show);

                var cache = {}
                this.task.ctrlColumns.forEach(item => {
                    if (!item.fixedShow) {
                        cache[item.key] = item.show
                    }
                })

                localStorage.setItem('PCS', JSON.stringify(cache))
            },
            /**
             * @description 获取项目列表
             */
            getProject () {
                this.request(this.API.myProject, {
                    method: 'post',
                    data: {
                        pageCount: 1,
                        pageSize: 9999999
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.projectOptions = res.data.list.map(item => {
                            return {
                                value: item.id,
                                label: item.projectName
                            }
                        })

                        var cache = this.getProjectTaskCache(),
                            projectId = this.$route.query.id;

                        if (projectId && this.projectOptions.filter(item => item.value == projectId).length > 0) {
                            this.projectValue = parseInt(projectId);
                            this.getTask()
                            this.getGroup()
                        } else if (cache && this.projectOptions.filter(item => item.value == cache.id).length > 0) {
                            this.projectValue = cache.id;
                            this.getTask()
                            this.getGroup()
                        } else if (this.projectOptions.length > 0) {
                            this.projectValue = this.projectOptions[0].value;
                            this.setProjectTaskCache()
                            this.getTask()
                            this.getGroup()
                        }
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 获取字段列表
             */
            getCustom (callback) {
                this.request(this.API.taskCustomList).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.task.ctrlColumns = this.task.ctrlColumns.concat(res.data.map(item => {
                            return { title: item.fieldName, dataIndex: 'ext' + item.id, key: 'ext' + item.id, width: 120, ext: true, show: false, ellipsis: true }
                        }).concat([{ title: '操作', dataIndex: 'ctrl', key: 'ctrl', width: 135, fixedShow: true, fixed: 'right' }]))

                        callback && callback()
                    }
                })
            },
            /**
           * @description 分页
           */
            tableChange (page) {
                this.task.pageInfo = page;
                this.getTask()
            },
            /**
             * @description 展开子任务
             */
            tableExpand (status, data, autoError = true, callback) {
                if (status) {
                    this.task.loading = true;

                    this.request(this.API.subTask, {
                        method: 'post',
                        data: {
                            taskId: data.id,
                            executorIdList: this.filter.executor,
                            principalIdList: this.filter.charge,
                            startTime: this.filter.start,
                            endTime: this.filter.end,
                            taskName: this.filter.title,
                            labelIdList: this.filter.tag
                        }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            res.data = res.data.map(item => {
                                item.pId = data.id;
                                return item
                            })

                            var children = this.formatTaskData(res.data, true, this.task.ctrlColumns);

                            data.children = children.length > 0 ? children : undefined

                        } else if (autoError) {
                            this.error(res.msg);
                        }

                        this.task.loading = false;

                        callback && callback(data.children)
                    }).catch(() => {
                        callback && callback(data.children)
                    })
                }


                this.setExpandCache(status, data.id)
            },
            /**
             * @description 获取任务
             */
            getTask () {
                if (!this.projectValue) {
                    return
                }

                this.task.loading = true;

                this.request(this.API.getTaskByProject, {
                    method: 'post',
                    data: {
                        projectId: this.projectValue,
                        pageCount: this.task.pageInfo.current,
                        pageSize: this.task.pageInfo.pageSize,
                        executorIdList: this.filter.executor,
                        principalIdList: this.filter.charge,
                        startTime: this.filter.start,
                        endTime: this.filter.end,
                        taskName: this.filter.title,
                        labelIdList: this.filter.tag
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.task.datas = this.formatTaskData(res.data.list, true, this.task.ctrlColumns)
                        this.task.expandedRowKeys = [];

                        this.task.loading = false;
                        this.task.pageInfo.total = res.data.total

                        var expand = this.getExpandCache()[this.projectValue] || []

                        this.expandedRowKeysPending = this.extend([], expand)
                        this.task.expandedRowKeys = expand;

                        this.checkTaskOpen(this.task.datas)
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            checkTaskOpen (data) {
                this.expandedRowKeysPending.forEach(item => {
                    var p = data.filter(fItem => fItem.id == item)[0]

                    p && item && this.tableExpand(true, p, false, (data) => {
                        this.expandedRowKeysPending = this.expandedRowKeysPending.filter(sItem => sItem != item)

                        if (this.expandedRowKeysPending.length > 0) {
                            this.checkTaskOpen(data)
                        }
                    });
                })
            },
            /**
             * @description 缓存展开数据
             * @param {*} id 
             */
            setExpandCache (status, id) {
                var cache = this.getExpandCache(),
                    project = cache[this.projectValue];

                if (project) {
                    if (status) {
                        if (project.filter(item => item == id).length <= 0) {
                            project.push(id)
                        }
                    } else {
                        project = project.filter(item => item != id)
                    }

                    cache[this.projectValue] = project
                } else {
                    if (status) {
                        cache[this.projectValue] = [id]
                    }
                }

                localStorage.setItem('PEC', JSON.stringify(cache))
            },
            /**
             * @description 获取展开数据缓存
             */
            getExpandCache () {
                var res = localStorage.getItem('PEC');

                if (res) {
                    return JSON.parse(res)
                } else {
                    return {}
                }
            },
            /**
             * @description 删除任务
             */
            deleteTask () {
                this.task.loading = true;

                var deletePromise = [];

                for (var i = 0; i < this.task.selectedRowKeys.length; i++) {
                    deletePromise.push(this.request(this.API.deleteTask, {
                        method: 'post',
                        params: { taskId: this.task.selectedRowKeys[i] }
                    }))
                }

                Promise.all(deletePromise).then(res => {
                    res = res.map((item, index) => {
                        item.name = this.task.datas[index].name;
                        return item
                    })

                    res = res.map((item, index) => {
                        item.name = this.task.selectedRows[index].title;
                        return item
                    })

                    var error = res.filter(item => item.code != this.REQUEST_SUCCESS_CODE),
                        errorNode = error.map((item, index) => createVNode('p', {}, item.name + '：' + item.msg));

                    if (error.length > 0) {
                        this.warning(createVNode('div', {}, [createVNode('p', {}, error.length + '个任务删除失败:')].concat(errorNode)))
                    } else {
                        this.success('删除成功')
                    }

                    this.onSelectChange([]);
                    this.getTask()
                })
            },
            /**
             * @description 创建任务
             */
            createTask (data) {
                if (data) {
                    this.parentTaskCache = { id: data.key, name: data.title }
                } else {
                    this.parentTaskCache = undefined
                }
                this.showAddTask = true;
            },
            /**
            * @description 创建任务
            */
            editTask (data) {
                this.showEditTask = true;
                this.parentTaskCache = {};
                this.$nextTick(() => {
                    this.$refs.editTaskBox.getDetail(data.key, true)
                })
            },
            exportTask () {
                this.request(this.API.exportTask, {
                    responseType: 'blob',
                    params: { projectId: this.projectValue }
                }).then(res => {
                    let url = window.URL.createObjectURL(new Blob([res])),
                        A = document.createElement('a');

                    A.style.display = 'none'
                    A.href = url
                    A.setAttribute('download', this.projectOptions.filter(item => item.value == this.projectValue)[0].label + '.xls')
                    A.click()

                    window.URL.revokeObjectURL(url)
                })
            },

            /**
            * @description 查看任务
            */
            viewTask (data) {
                console.log('view');
                this.showEditTask = true;
                this.parentTaskCache = {};
                this.$nextTick(() => {
                    this.$refs.editTaskBox.getDetail(data.key, false)
                })
            },
            /**
             * @description 更新任务状态
             */
            updateTaskStatus (res, data) {
                data.statusLoading = true;

                this.request(this.API.updateTaskStatus, {
                    method: 'post',
                    data: { taskId: data.key, status: res }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('更新状态成功')
                        data.statusLoading = false;
                    } else {
                        this.error(res.msg)
                    }
                })
            },
            /**
             * @description 缓存看板筛选
             */
            setBoardFilterCache (item) {
                var cache = this.getBoardFilterCache();

                cache[item.id] = {
                    showChildren: item.showChildren,
                    showComplete: item.showComplete,
                    showOutdate: item.showOutdate,
                    showPending: item.showPending,
                    showProgress: item.showProgress,
                    showSuspend: item.showSuspend
                }

                localStorage.setItem('BFC', JSON.stringify(cache))
            },
            getBoardFilterCache () {
                return JSON.parse(localStorage.getItem('BFC') || '{}')
            },
            /**
             * @description 看板筛选功能算法
             */
            checkShow (item, sItem) {
                if (sItem.status == 0 && !item.showOutdate) {
                    return false
                }

                if (sItem.status == 1 && !item.showPending) {
                    return false
                }

                if (sItem.status == 2 && !item.showProgress) {
                    return false
                }
                
                if (sItem.status == 4 && !item.showSuspend) {
                    return false
                }

                if (sItem.status == 3 && !item.showComplete) {
                    return false
                }

                if (sItem.parentId != 0 && !item.showChildren) {
                    return false
                }

                return true
            },
            /**
             * @description 获取分组
             */
            getGroup () {
                if (!this.projectValue) {
                    return
                }

                this.request(this.API.getTaskPanel, {
                    method: 'post',
                    data: {
                        projectId: this.projectValue,
                        pageSize: 9999,
                        pageIndex: 1,
                        executorIdList: this.filter.executor,
                        principalIdList: this.filter.charge,
                        startTime: this.filter.start,
                        endTime: this.filter.end,
                        taskName: this.filter.title,
                        labelIdList: this.filter.tag,
                        teamAdList: this.filter.onlyLeader
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {

                        var cache = this.getBoardFilterCache();

                        this.group = res.data.map(item => {
                            var groupCache = cache[item.groupId + ''];

                            return {
                                id: item.groupId,
                                name: item.groupName,
                                taskList: item.taskList.map(item => {
                                    item.key = item.taskId;
                                    item.id = item.taskId;
                                    return item
                                }),
                                edit: false,
                                loading: false,
                                showChildren: groupCache ? groupCache['showChildren'] : false,
                                showComplete: groupCache ? groupCache['showComplete'] : false,
                                showProgress: groupCache ? groupCache['showProgress'] : true,
                                showSuspend: groupCache ? groupCache['showSuspend'] : true,
                                showPending: groupCache ? groupCache['showPending'] : true,
                                showOutdate: groupCache ? groupCache['showOutdate'] : true,
                            }
                        })

                        this.$nextTick(this.initDrag)
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 重命名
             */
            edit (data) {
                data.edit = true;
                this.groupNameCache = data.name
            },
            /**
             * @description 重命名分组
             */
            saveGroup (data) {
                data.loading = true;

                var name = this.$refs['groupName' + data.id][0].stateValue || '未分组';

                if (data.id.toString().indexOf('cache') == 0) {
                    this.request(this.API.addGroup, {
                        method: 'post',
                        data: {
                            projectId: this.projectValue,
                            groupName: name
                        }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            data.loading = false;
                            data.edit = false;
                            data.name = name;
                            this.success('添加成功')
                        } else {
                            this.error(res.msg);
                        }
                    })
                } else {
                    this.request(this.API.updateGroup, {
                        method: 'post',
                        data: {
                            groupId: data.id,
                            groupName: name
                        }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            data.loading = false;
                            data.edit = false;
                            data.name = name;
                            this.success('重命名成功')
                        } else {
                            this.error(res.msg);
                        }
                    })
                }
            },
            /**
             * @description 添加分组
             */
            addGroup () {
                if (this.group.filter(item => item.edit).length > 0) {
                    this.warning('请先保存尚未保存的分组信息');
                    return
                }

                var group = this.extend([], this.group);

                group.push({
                    id: 'cache-' + new Date().getTime(),
                    name: '',
                    taskList: {},
                    edit: true,
                    loading: false
                })

                this.group = group;

                this.$nextTick(() => {
                    this.$refs.panelScroll.scrollLeft = this.$refs.panelScroll.scrollWidth
                })
            },
            /**
             * @description 删除分组
             */
            deleteGroup (data) {
                data.loading = true;

                if (data.id.toString().indexOf('cache') == 0) {
                    this.group = this.group.filter(item => item.id != data.id)
                } else {
                    this.request(this.API.deleteGroup, {
                        params: {
                            groupId: data.id
                        }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            this.group = this.group.filter(item => item.id != data.id)
                        } else {
                            this.error(res.msg);
                        }

                        data.loading = false;
                    }).catch(err => {
                        data.loading = false;
                    })
                }
            },
            onSelectChange (selectedRowKeys, selectedRows) {
                this.task.selectedRowKeys = selectedRowKeys
                this.task.selectedRows = selectedRows
            },
            /**
             * @description 切换项目更新数据
             */
            projectChange () {
                this.setProjectTaskCache()
                this.getTask()
                this.getGroup()

                this.$nextTick(() => {
                    this.$refs.editTaskBox && this.showEditTask && this.$nextTick(() => {
                        this.$refs.editTaskBox.getDetail()
                    })
                })
            },
            setProjectTaskCache () {
                localStorage.setItem('PTC', JSON.stringify({ id: this.projectValue, name: this.projectOptions.filter(item => item.value == this.projectValue)[0].label }))
            },
            getProjectTaskCache () {
                var res = localStorage.getItem('PTC');

                if (res) {
                    return JSON.parse(res)
                } else {
                    return null
                }
            },
            tabChange () {
                this.setProjectTaskTabCache()
                this.getTask()
                this.getGroup()
            },
            setProjectTaskTabCache () {
                this.$nextTick(this.initDrag)
                return localStorage.setItem('PTTC', this.type)
            },
            getProjectTaskTabCache () {
                return localStorage.getItem('PTTC')
            },
            /**
             * @description 删除筛选条件
             */
            deleteFilter (item) {
                if (item.key == 'title' || item.key == 'start' || item.key == 'end') {
                    this.filter[item.key] = ''
                } else {
                    this.filter[item.key] = []
                    this.filter[item.key + 's'] = []
                }

                this.getTask()
                this.getGroup()
                this.setOnlyLeaderCache()
            }
        }),
        components: {
            AddTaskBox,
            FilterTask
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .c-task-list {
        height: calc(100vh - 355px);

        ul {
            position: relative;
            min-height: 100%;

            .c-task-list-empty {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -100%);
            }
        }

        .c-task-list-item {
            position: relative;
            z-index: 5;

            & + .c-task-list-empty {
                display: none;
            }
        }
    }

    .c-task-panel-item {
        width: 300px;
    }

    @media screen and (max-width: 992px) {
        .c-task-list {
            height: calc(100vh - 395px);
        }

        .ctrl-row {
            margin-top: $margin-padding-2;
        }
    }
</style>
<style>
    .c-tab-container > .ant-tabs-card .ant-tabs-content {
        margin-top: -16px;
    }
</style>